"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.link.js");
require("core-js/modules/es6.array.map.js");
require("core-js/modules/es6.function.name.js");
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _button = _interopRequireDefault(require("@gravity/button"));
var _jsxFileName = "/codebuild/output/src3938275692/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/functional/TsHeader/lib/CustomLinks.js",
  _templateObject,
  _templateObject2,
  _templateObject3;
function cov_n6x5lg6pf() {
  var path = "/codebuild/output/src3938275692/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/functional/TsHeader/lib/CustomLinks.js";
  var hash = "3211376de48f936c645820417854cd4b6d859650";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3938275692/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/functional/TsHeader/lib/CustomLinks.js",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 16
        },
        end: {
          line: 15,
          column: 1
        }
      },
      "1": {
        start: {
          line: 17,
          column: 20
        },
        end: {
          line: 21,
          column: 1
        }
      },
      "2": {
        start: {
          line: 23,
          column: 25
        },
        end: {
          line: 44,
          column: 1
        }
      },
      "3": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 33,
          column: 3
        }
      },
      "4": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 43,
          column: 7
        }
      },
      "5": {
        start: {
          line: 48,
          column: 22
        },
        end: {
          line: 48,
          column: 64
        }
      },
      "6": {
        start: {
          line: 48,
          column: 48
        },
        end: {
          line: 48,
          column: 63
        }
      },
      "7": {
        start: {
          line: 50,
          column: 2
        },
        end: {
          line: 60,
          column: 4
        }
      },
      "8": {
        start: {
          line: 53,
          column: 8
        },
        end: {
          line: 57,
          column: 22
        }
      },
      "9": {
        start: {
          line: 63,
          column: 0
        },
        end: {
          line: 71,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 29,
            column: 4
          },
          end: {
            line: 29,
            column: 5
          }
        },
        loc: {
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 33,
            column: 3
          }
        },
        line: 30
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 33,
            column: 7
          },
          end: {
            line: 33,
            column: 8
          }
        },
        loc: {
          start: {
            line: 34,
            column: 4
          },
          end: {
            line: 43,
            column: 7
          }
        },
        line: 34
      },
      "2": {
        name: "CustomLinks",
        decl: {
          start: {
            line: 46,
            column: 9
          },
          end: {
            line: 46,
            column: 20
          }
        },
        loc: {
          start: {
            line: 46,
            column: 32
          },
          end: {
            line: 61,
            column: 1
          }
        },
        line: 46
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 48,
            column: 38
          },
          end: {
            line: 48,
            column: 39
          }
        },
        loc: {
          start: {
            line: 48,
            column: 48
          },
          end: {
            line: 48,
            column: 63
          }
        },
        line: 48
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 52,
            column: 23
          },
          end: {
            line: 52,
            column: 24
          }
        },
        loc: {
          start: {
            line: 53,
            column: 8
          },
          end: {
            line: 57,
            column: 22
          }
        },
        line: 53
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 33,
            column: 3
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 30,
            column: 15
          }
        }, {
          start: {
            line: 31,
            column: 4
          },
          end: {
            line: 33,
            column: 3
          }
        }],
        line: 30
      },
      "1": {
        loc: {
          start: {
            line: 34,
            column: 4
          },
          end: {
            line: 43,
            column: 7
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 34,
            column: 4
          },
          end: {
            line: 34,
            column: 14
          }
        }, {
          start: {
            line: 35,
            column: 4
          },
          end: {
            line: 43,
            column: 7
          }
        }],
        line: 34
      },
      "2": {
        loc: {
          start: {
            line: 36,
            column: 14
          },
          end: {
            line: 36,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 36,
            column: 14
          },
          end: {
            line: 36,
            column: 44
          }
        }, {
          start: {
            line: 36,
            column: 48
          },
          end: {
            line: 36,
            column: 70
          }
        }],
        line: 36
      },
      "3": {
        loc: {
          start: {
            line: 42,
            column: 16
          },
          end: {
            line: 42,
            column: 82
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 42,
            column: 16
          },
          end: {
            line: 42,
            column: 46
          }
        }, {
          start: {
            line: 42,
            column: 50
          },
          end: {
            line: 42,
            column: 72
          }
        }, {
          start: {
            line: 42,
            column: 76
          },
          end: {
            line: 42,
            column: 82
          }
        }],
        line: 42
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "3211376de48f936c645820417854cd4b6d859650"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_n6x5lg6pf = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_n6x5lg6pf();
var Wrapper = (cov_n6x5lg6pf().s[0]++, _styledComponents.default.ul.attrs({
  className: 'stx-CustomLinksContainer'
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  font-size: 16px;\n  width:100%;\n  text-align:right;\n  margin: 0;\n  padding: 0;\n"]))));
var ItemWrapper = (cov_n6x5lg6pf().s[1]++, _styledComponents.default.li.attrs({
  className: 'stx-CustomLinkItemContainer'
})(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  display: inline-block;\n"]))));
var CustomLinkButton = (cov_n6x5lg6pf().s[2]++, (0, _styledComponents.default)(_button.default).attrs({
  className: 'stx-CustomLinkButton'
})(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["\n  font-weight: 600;\n  margin-right: 3px;\n  font-size: 16px;\n  ", " ", ";\n"])), function (props) {
  cov_n6x5lg6pf().f[0]++;
  cov_n6x5lg6pf().s[3]++;
  return (cov_n6x5lg6pf().b[0][0]++, !props.flat) && (cov_n6x5lg6pf().b[0][1]++, "\n    margin-left: 14px;\n  ");
}, function (props) {
  cov_n6x5lg6pf().f[1]++;
  cov_n6x5lg6pf().s[4]++;
  return (cov_n6x5lg6pf().b[1][0]++, props.flat) && (cov_n6x5lg6pf().b[1][1]++, "\n     color: ".concat((cov_n6x5lg6pf().b[2][0]++, props.theme.tsHeader.textColor) || (cov_n6x5lg6pf().b[2][1]++, props.theme.link.color), ";\n     &:not(:disabled):hover,\n     &:not(:disabled):focus,\n     &:focus,\n     &:active,\n     &:hover {\n       color: ").concat((cov_n6x5lg6pf().b[3][0]++, props.theme.tsHeader.textColor) || (cov_n6x5lg6pf().b[3][1]++, props.theme.link.color) || (cov_n6x5lg6pf().b[3][2]++, '#000'), ";\n     }"));
}));
function CustomLinks(_ref) {
  var _this = this;
  var links = _ref.links;
  cov_n6x5lg6pf().f[2]++;
  // sort custom links by rank
  var sortedLinks = (cov_n6x5lg6pf().s[5]++, (0, _toConsumableArray2.default)(links).sort(function (a, b) {
    cov_n6x5lg6pf().f[3]++;
    cov_n6x5lg6pf().s[6]++;
    return a.rank - b.rank;
  }));
  cov_n6x5lg6pf().s[7]++;
  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 5
    }
  }, sortedLinks.map(function (link) {
    cov_n6x5lg6pf().f[4]++;
    cov_n6x5lg6pf().s[8]++;
    return /*#__PURE__*/_react.default.createElement(ItemWrapper, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 53,
        columnNumber: 9
      }
    }, /*#__PURE__*/_react.default.createElement(CustomLinkButton, {
      small: true,
      href: link.url,
      key: link.url,
      flat: link.style === 'link',
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 54,
        columnNumber: 11
      }
    }, /*#__PURE__*/_react.default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: link.name
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 55,
        columnNumber: 13
      }
    })));
  }));
}
cov_n6x5lg6pf().s[9]++;
CustomLinks.propTypes = {
  links: _propTypes.default.arrayOf(_propTypes.default.shape({
    rank: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    style: _propTypes.default.string,
    name: _propTypes.default.objectOf(_propTypes.default.string)
  })).isRequired
};
var _default = exports.default = CustomLinks;